// vendors
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { theme } from "../../../../Customization/Theme";

type EditorMainWrapperStyledProps = {
  error: boolean;
};

export const EditorMainWrapperStyled = styled(
  Box
)<EditorMainWrapperStyledProps>(({ error }) => ({
  backgroundColor: "#F5F6F8",
  padding: "12px",
  borderRadius: "4px",
  color: "#7E8392",
  ...(error && {
    border: "1px solid red",
    backgroundColor: "rgb(243 209 209 / 36%)",
  }),
  ".public-DraftEditor-content .public-DraftStyleDefault-block": {
    opacity: 1,
    color: theme.palette.default.black,
  },
}));

export const EditorInnerWrapperStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== "readOnly",
})<{ readOnly?: boolean }>(({ theme, readOnly }) => ({
  position: "relative",
  paddingBottom: "32px",
  "& .public-DraftEditorPlaceholder-inner": {
    position: "absolute",
    width: "100%",
  },
  "& .DraftEditor-root":{
    pointerEvents: readOnly ? "none" : "auto",
  },
  "& .public-DraftStyleDefault-block": {
    height: "100%",
    top: 0,
    position: "relative",
    zIndex: 1,
    width: "100%",
    fontSize: "20px",
    lineHeight: "21px",
    color: "#7E8392",
    fontWeight: 400,
    fontFamily: "Rubik', sans-serif",
  },
  "& .DraftEditor-editorContainer": {
    paddingBottom: "30px",
    minHeight: "38px",
  },
  "& .public-DraftEditor-content": {
    minHeight: "38px",
  },
  cursor: "text",

  "& .public-DraftEditorPlaceholder-root": {
    position: "absolute",
    fontSize: "14px",
    lineHeight: "21px",
    fontWeight: 400,
    fontFamily: "Rubik', sans-serif",
    color: "#7E8392",
    opacity: 0.42,
  },

  "& .public-DraftStyleDefault-ul": {
    marginLeft: "40px",
  },
  "& .public-DraftStyleDefault-ol": {
    marginLeft: "40px",
  },
}));

export const UploadSectionCloseButtonStyled = styled(IconButton)(
  ({ theme }) => ({
    backgroundColor: "white",
    border: "1px solid #CBCDD3",
    padding: "4px",
    position: "absolute",
    top: "-10px",
    right: "-10px",
    zIndex: 1,
    "&:hover": {
      backgroundColor: "white",
    },
  })
);
